

















































































































































































import { Component, Mixins, Watch, Ref, Prop } from "vue-property-decorator";

import { ValidationObserver, ValidationProvider } from "vee-validate";

import BaseDropdown from "@/components/BaseDropdown/BaseDropdown.vue";
import InputRow from "@/components/InputRow/InputRow.vue";
import TextField from "@/components/TextField/TextField.vue";
import AsyncButton from "@/components/BaseAsyncButton/BaseAsyncButton.vue";
import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import BaseAlert from "@/components/BaseAlert/BaseAlert.vue";
import BaseCheckbox from "@/components/BaseCheckbox/BaseCheckbox.vue";

import RequestState from "@/utils/mixins/RequestState";

import { Action, State } from "vuex-class";
import { AxiosResponse } from "axios";

import { ITeacher, ITeacherPayload } from "@/models/interfaces/teachers";
import { IVuexState } from "@/models/interfaces/store";
import { ISchool } from "@/models/interfaces/schools";
import { IClass } from "@/models/interfaces/classes";

@Component({
  components: {
    BaseDropdown,
    InputRow,
    TextField,
    AsyncButton,
    BaseSpinner,
    BaseAlert,
    BaseCheckbox,

    ValidationObserver,
    ValidationProvider
  }
})
export default class TeacherForm extends Mixins(RequestState) {
  @Prop({ type: Object })
  private initialData!: ITeacher;

  @State("schools", { namespace: "schools" })
  private schools!: IVuexState<ISchool[]>;

  @State("classes", { namespace: "classes" })
  private classes!: IVuexState<IClass[]>;

  @Action("students/generateUsername")
  private generateUsername!: (params: {
    firstname: string;
    lastname: string;
  }) => Promise<AxiosResponse>;

  @Action("schools/fetchSchools")
  private fetchSchools!: () => Promise<{ schools: ISchool[] }>;

  @Action("classes/fetchClassesForSchool")
  private fetchClassesForSchool!: (
    schoolsIds: string[]
  ) => Promise<{ classes: IClass[] }>;

  private isSubmitting = false;
  private isGeneratingUsername = false;
  private isAdmin = false;

  private schoolId = "";
  private initialClassIds: string[] = [];

  private form: ITeacherPayload | {} = {};

  private get isEditMode() {
    return this.$route.fullPath.includes("edit");
  }

  private get schoolsOptions() {
    return this.schools.data?.map(({ schoolName, schoolId }) => ({
      label: schoolName,
      value: schoolId
    }));
  }

  private get classesOptions() {
    return this.schoolId && !this.isEmpty(this.classes)
      ? this.classes.data!.map(item => ({
          label: item.className,
          value: item.classId
        }))
      : [];
  }

  private get passwordRules() {
    if (this.isEditMode) {
      const form = this.form as ITeacherPayload;
      return form.password ? "min:6" : "";
    } else {
      return "required|min:6";
    }
  }

  private setLoadingState(state: boolean) {
    this.isSubmitting = state;
  }

  private async onGenerateUsername() {
    if (this.isEditMode) {
      // TODO: Remove this condition as soon as API is done
      this.$emit("on-popup-toggle", this.$t("components.errors.teacherEdit"));
      return;
    }

    const { firstname, lastname } = this.form as ITeacherPayload;

    if (!firstname || !lastname) {
      this.$emit("on-popup-toggle", this.$t("components.errors.teacherNames"));
      return;
    }

    this.isGeneratingUsername = true;

    this.generateUsername({
      firstname,
      lastname
    })
      .then(({ data }) => {
        (this.form as ITeacherPayload).username = data.username;
      })
      .catch(() => {
        this.$emit(
          "on-popup-toggle",
          this.$t("components.errors.teacherNames")
        );
      })
      .finally(() => {
        this.isGeneratingUsername = false;
      });
  }

  private submit() {
    const form = { ...this.form, tdAdmin: this.isAdmin };

    if (this.isEditMode) {
      this.$emit("submit", form);
      return;
    }

    this.$emit("submit", form);
  }

  public async mounted() {
    await this.fetchSchools();

    if (this.initialData) {
      const {
        username,
        firstname,
        lastname,
        schools,
        tdAdmin
      } = this.initialData;
      const schoolExists = Boolean(schools[0]);

      this.isAdmin = tdAdmin;
      this.schoolId = schoolExists ? schools[0].schoolId : "";
      this.initialClassIds = schoolExists
        ? schools[0].classes?.map(item => item.classId) || []
        : [];

      this.form = Object.assign(this.form, {
        username,
        firstname,
        lastname
      });
    }
  }

  @Watch("schoolId")
  private async onSchoolSelected() {
    if (this.schoolId) {
      await this.fetchClassesForSchool([this.schoolId]);

      if (this.initialClassIds) {
        this.form = Object.assign(this.form, {
          classIds: this.initialClassIds
        });

        this.initialClassIds = [];
      }
    }
  }
}
